import { Controller } from 'stimulus';
import accessibleAutocomplete from 'accessible-autocomplete';

export default class extends Controller {
  static targets = ['hiddenInput', 'selectElement'];

  connect() {
    if (this.selectElementTarget) {
      accessibleAutocomplete.enhanceSelectElement({
        confirmOnBlur: false,
        defaultValue: '',
        displayMenu: 'overlay',
        dropdownArrow: () => null,
        onConfirm: this._handleConfirm.bind(this),
        selectElement: this.selectElementTarget,
        showAllValues: true,
        source: this._suggestResults.bind(this),
        templates: {
          suggestion: this._suggestion,
          inputValue: result => result && result.value,
        },
      });
    }
  }

  _handleConfirm(valuePair) {
    const { value } = valuePair;
    const event = new Event('selection');
    this.hiddenInputTarget.value = value;
    this.hiddenInputTarget.dispatchEvent(event);
  }

  _suggestResults(query, populateResults) {
    const trimQuery = query.trim();
    const trimQueryLowerCase = trimQuery.toLowerCase();
    const source = Array.from(this.selectElementTarget.options)
      .map(option => ({
        additionalFilterValue: option.dataset.additionalFilterValue,
        value: option.value,
        name: option.innerText,
      }))
      .filter(e => e.value !== '');

    const nameMatches = source.filter(
      i => i.name.toLowerCase().indexOf(trimQueryLowerCase) !== -1
    );

    const additionalFilterMatches = source.filter(i => {
      if (!i.additionalFilterValue) return false;

      return (
        i.additionalFilterValue.toLowerCase().indexOf(trimQueryLowerCase) !==
          -1 && !nameMatches.find(m => m.value === i.value)
      );
    });

    const matches = [...nameMatches, ...additionalFilterMatches];

    populateResults(matches);
  }

  _suggestion(result) {
    if (!result.additionalFilterValue) return result.name;

    return `<p>
      <strong>${result.name}</strong><br>
      <em>${result.additionalFilterValue}</em>
    </p>`;
  }
}
